import styled from "styled-components";
import { theme } from "theme";

export const Wrapper = styled.div`
  width: 100%;
  
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    padding: 60px 16px 100px 16px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 0 190px;
  max-width: 692px;
  max-height: 684px;
  width: 100%;
  height: 100%;
  background: rgba(249, 242, 236, 1);
  border-radius: 8px;

  @media (max-width: ${theme.breakpoints.sm}) {
    margin: auto;
    padding: 0 8%;
    max-height: 430px;
  }
  
`;

export const FormParent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ForgotPassword = styled.div<{ isError?: boolean }>`
  font-size: 12px;
  color: ${({ isError }) =>
    isError ? "rgba(201, 54, 54, 1)" : theme.palette.primary};
  margin-top: 6px;
  cursor: pointer;
  text-decoration: underline;
`;
